import { post,get,put } from '@/utils/request'

/**
 * 查询角色
 * @param data
 * @returns {*}
 */
export function listRolesAPI(params) {
    return get({
        params,
        url: 'member/roles'
    })
}

/**
 * 添加角色
 * @param data
 * @returns {*}
 */
export function addRoleAPI(data) {
    return post({
        url: `member/roles`,
        data: data,
    })
}

/**
 * 修改角色
 * @param data
 * @returns {*}
 */
export function updateRoleAPI(data) {
    return put({
        url: `member/roles`,
        data: data,
    })
}


/**
 * 获取橘色所拥有的菜单
 * @param data
 * @returns {*}
 */
export function listRolesMenusAPI(roleId) {
    return get({
        url: `member/roles/${roleId}/menus`
    })
}


/**
 * 添加角色菜单授权
 * @param data
 * @returns {*}
 */
export function addRolesMenusAPI(data) {
    return post({
        url: `member/roles/menus`,
        data
    })
}
